<template>
  <div id="login" class="hold-transition login-page">
    <div class="login-box">
      <div class="login-logo">
        <a href="https://www.soonnet.org/">
          <b> {{ $t('loginFun.login.administrator') }}</b>
        </a>
      </div>
      <!-- /.login-logo -->
      <div class="card" style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <div class="card-body login-card-body">
          <el-form :model="loginmodel" ref="loginmodel" :rules="loginrules">
            <el-form-item label prop="username" class="mb-3">
              <el-input
                v-model="loginmodel.username"
                autocomplete="off"
                :placeholder="$t('loginFun.login.username')"
              >
                <i
                  class="el-icon-user"
                  style="font-style: normal"
                  slot="suffix"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item label prop="password" class="mb-3">
              <el-input
                v-model="loginmodel.password"
                show-password
                :placeholder="$t('loginFun.login.password')"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                class="btn btn-primary btn-block"
                @click="submitForm('loginmodel')"
                > {{ $t('loginFun.login.loginmodel') }}</el-button
              >
              <!-- <el-form-item>
                <div class="text-center mt-2">
                  <button
                    type="primary"
                    @click="onFBLogin()"
                    id="fblogin"
                    btn
                    btn-block
                    btn-sm
                    style="background-color: 845ff6; color: white"
                    class="btn btn-block"
                  >
                    <i class="fab fa-facebook mr-2"></i> 以 Facebook 帳號登入
                  </button>
                </div>
              </el-form-item> -->
              <el-form-item>
                <div class="additional-row mb-4">
                  <span class="additional-text"> {{ $t('loginFun.login.or') }}</span>
                </div>
                <el-button
                  type="primary"
                  @click="onFBLogin()"
                  id="fblogin"
                  icon="fab fa-facebook"
                  class="btn btn-block fb-login-button btn-lg"
                  > {{ $t('loginFun.login.facebook') }}</el-button
                >
                <!-- <a href="#" class="btn btn-block fb-login-button btn-lg">
                <i class="fab fa-facebook mr-2"></i> 以 Facebook 帳號登入
              </a> -->
              </el-form-item>
            </el-form-item>
          </el-form>
        </div>
        <!-- /.login-card-body -->
      </div>
    </div>
  </div>
</template>
<style scoped>
@import "../../assets/backCss/font-awesome/all.min.css";
@import "../../assets/plugins/datatables-bs4/css/dataTables.bootstrap4.css";
@import "../../assets/plugins/toastr/toastr.min.css";
@import "../../assets/backCss/adminlte/adminlte.css";
@import "../../assets/backCss/desktop/normalize.css";
@import "../../assets/backCss/desktop/main.css";
</style>
<script>
import "../../assets/backJs/adminlte.min.js";
import { Message } from "element-ui";
import base from "../../api/httpApi/base";
export default {
  name: "login",
  data() {
    return {
      //登錄實體
      loginmodel: {
        username: "",
        password: "",
      },
      //登錄驗證
      loginrules: {
      },
    };
  },
  created(){
    this.setloginrules();
  },
  watch:{
    '$i18n.locale': function () {
      this.setloginrules();
    },
  },
  methods: {
    setloginrules(){
      const that = this;
      this.loginrules = {
        username: [
          {
            required: true,
            message: that.$t('loginFun.login.loginrules.username'),
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: that.$t('loginFun.login.loginrules.password'), trigger: "blur" }],
      }
    },
    submitForm(formname) {
      this.$refs[formname].validate((valid) => {
        if (!valid) {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
        }
        let params = {
          name: this.loginmodel.username,
          pwd: this.loginmodel.password,
        };
        this.$store.dispatch("adminLogin", params).then((res) => {
          if (res) {
            this.$router.push({
              name: "adminDefaultIndex",
            });
          } else {
            Message({
              type: "error",
              message: "用戶名或密碼輸入錯誤",
            });
          }
        });
      });
    },
    loadFBSDK() {
      const params =
        "#version=v3.3&appId=504404792941839&status=true&cookie=true&xfbml=true&autoLogAppEvents=true";
      (function (d, s, id) {
        // Load the SDK asynchronously
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/zh_TW/sdk.js" + params;
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },
    onFBLogin() {
      this.loadFBSDK();
      const _this = this;
      // 检测FB登录状态
      FB.getLoginStatus(function (response) {
        // console.log("请求成功");
        if (response.status === "connected") {
          let params = {
            accessToken: response.authResponse.accessToken,
            userID: response.authResponse.userID,
            expiresIn: response.authResponse.expiresIn,
            signedRequest: response.authResponse.signedRequest,
          };
          // console.log(params.accessToken);
          _this.$store.dispatch("adminFaceLogin", params).then((res) => {
            if (res) {
              this.$router.push({
                name: "adminDefaultIndex",
              });
            } else {
              Message({
                type: "error",
                message: "用戶名或密碼輸入錯誤",
              });
            }
          });
        } else {
          // 未登录进行登录
          FB.login(
            function (response) {
              if (response.status === "connected") {
                let params = {
                  accessToken: response.authResponse.accessToken,
                  userID: response.authResponse.userID,
                  expiresIn: response.authResponse.expiresIn,
                  signedRequest: response.authResponse.signedRequest,
                };
                console.log(params.accessToken);
                _this.$store.dispatch("adminFaceLogin", params).then((res) => {
                  if (res == true) {
                    this.$router.push({
                      name: "adminDefaultIndex",
                    });
                  } else {
                    Message({
                      type: "error",
                      message: "用戶名或密碼輸入錯誤",
                    });
                  }
                });

                // Logged into your webpage and Facebook.
                // _this.handleSomething();
              } else {
                console.log("登录失败");

                // The person is not logged into your webpage or we are unable to tell.
              }
            }
            // { scope: "public_profile,email" }
          );
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/login/login.vue